<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12" id="autocomplete_container">
                <h4>Allegati del candidato</h4>
                <p>
                    Aggiungere un elenco di allegati che il candidato dovrà inserire obbligatoriamente o facoltativamente per inviare la candidatura
                </p>
            </div>
        </div>

        <div class="row pb-0 mt-0 mb-0">
            <div class="col-md-4">Tipo allegato</div>
            <div class="col-md-3">Testo di aiuto</div>
            <div class="col-md-2">Obbligatorio</div>
            <div class="col-md-3">&nbsp;</div>
        </div>
        <div class="row pb-0 mt-0 mb-0 border-t-1 border-light" v-for="(allegato,csid) in finalData.allegati"
             :key="'all_'+csid">
            <div class="col-md-4 pt-1 pb-0 mt-0 mb-0 ">
                <v-autocomplete
                    attach
                    dense
                    :items="tipiallegato"
                    color="white"
                    v-model="allegato.nome"
                    label="Tipo allegato"
                ></v-autocomplete>
            </div>
            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                <v-textarea v-model="allegato.help"
                            hint="spiega al candidato l'allegato (opzionale)"
                            placeholder="spiega al candidato l'allegato (opzionale)"
                ></v-textarea>
            </div>
            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                <v-switch dense v-model="allegato.mandatory"></v-switch>
            </div>
            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                <v-btn @click="removeAllegato(allegato)" color="error">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn @click="cloneAllegato(csid)" color="blue-grey">
                    <v-icon class="text--white" style="color:#FFF;">mdi-content-copy</v-icon>
                </v-btn>
            </div>
        </div>
        <div class="row pb-0 mb-0 border-t-1 border-light">
            <div class="col-md-12 text-right pb-0 mt-0 mb-0 ">
                <v-btn @click="addAllegato" color="primary">
                    <v-icon class="glyphicon-plus"></v-icon>
                    Aggiungi allegato
                </v-btn>
            </div>
        </div>

    </div>

</template>
<script>
var moment = require('moment');
const _ = require('lodash');
const _allegati = [
    "Curriculum vitae",
    "Documento di identità",
    "Codice fiscale/Tessera sanitaria",
    "Passaporto",
    "Allegato 1",
    "Allegato 2",
    "Allegato 3",
    "Documento di candidatura autogenerato",
    "Altro"
]
moment.locale("it");

var axios = require('axios');
export default {
    props: {
        "output": "",
        "source": {
            type: Object,
            default: () => {
            }
        }
    },
    computed: {
        tipiallegato: function () {
            return _allegati;
        }
    },
    data() {
        return {
            isLoading: false,
            "ready": false,
            "finalData": {
                "allegati": []
            }
        }
    },
    watch: {
        finalData: {
            handler(newValue, oldValue) {
                if (this.output) {
                    document.getElementById(this.output).value = JSON.stringify(this.finalData);
                }
            },
            deep: true
        }
    },
    methods: {


        cloneAllegato(id) {
            const _corso = _.cloneDeep(this.finalData.allegati[id]);
            this.finalData.allegati.push(_corso);
        },
        removeAllegato(obj) {
            this.finalData.allegati.splice(this.finalData.allegati.indexOf(obj), 1);
        },
        addAllegato() {
            this.finalData.allegati.push({
                "nome": "",
                "help": "",
                "mandatory": false
            });
        }
    },
    mounted() {
        this.$set(this.finalData, 'allegati', []);
        if (this.source) {
            if (this.source.allegati) {
                if (Array.isArray(this.source.allegati))
                    this.finalData.allegati = this.source.allegati;
            }
        }
        this.ready = true;
    }
}

</script>
